import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, TextField } from "@mui/material";
import React, { useState } from "react";
import CheckIcon from '@mui/icons-material/Check';
import { useAddStore } from "../Services/Store/StoreHooks";
import { Store } from "../Services/Store/StoreApi";


interface AddStoreModalProps {
    open: boolean
    onClose: () => void
    onSelect: (store: Store) => void
}

export default function AddStoreModal(props: AddStoreModalProps) {
    const [displaySuccessBar, setDisplaySuccessBar] = useState(false);

    const [storeName, setStoreName] = useState("");

    const isNameValid = storeName === "";

    const addStoreMutation = useAddStore();

    
    

    const handleAddStore = () => {

        const newStore = { name: storeName } as Store;
        addStoreMutation.mutate(newStore, {
            onSuccess: (store) => {
                setDisplaySuccessBar(true);
                setStoreName("");
                props.onSelect(store);
                props.onClose();
                addStoreMutation.reset();
            }
        });
        
    }


    const handleSnackbarClose = () => setDisplaySuccessBar(false);

    return (
            <Dialog
                open={props.open}
                onClose={props.onClose}
            >
                <DialogTitle>{"Add Store"}</DialogTitle>
            <DialogContent>
                <Box sx={{ my: 1 }}>
                    <TextField
                        label="Name"
                        value={storeName}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setStoreName(event.target.value);
                        }}     
                    />
                </Box>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isNameValid} onClick={handleAddStore}>Add Store</Button>
                </DialogActions>
                <Snackbar
                    open={displaySuccessBar}
                    autoHideDuration={2000}
                    onClose={handleSnackbarClose}
                >
                    <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                        Store Added Successfully
                    </Alert>
                </Snackbar>
            </Dialog>
    );
}

